import React, { memo, useEffect, useMemo, useState } from "react";
import "./UserBalanceHero.css";

const getMainBalance = (data) => {
  return (
    data?.mainBalance ??
    data?.main_balance ??
    data?.balance ??
    data?.wallet ??
    data?.amount ??
    0
  );
};

const normalizeUserData = (data = {}) => {
  return {
    username: data.username || "Unknown User",
    mainBalance: getMainBalance(data),
    freeEventWallet: data.vip_coin ?? data.freeEventWallet ?? 0,
  };
};

function UserBalanceHero({
  user: userProp = null,
  apiBaseUrl = process.env.REACT_APP_API_URL,
  className = "",
}) {
  const [user, setUser] = useState(
    userProp
      ? normalizeUserData(userProp)
      : {
          username: "Loading...",
          mainBalance: 0,
          freeEventWallet: 0,
        }
  );

  const [loading, setLoading] = useState(!userProp);
  const [error, setError] = useState("");

  useEffect(() => {
    if (userProp) {
      setUser(normalizeUserData(userProp));
      setLoading(false);
      return;
    }

    let isMounted = true;

    const fetchUserData = async () => {
      const token = localStorage.getItem("token");
      const remoteId = localStorage.getItem("remote_id");

      if (!token || !remoteId) {
        if (isMounted) {
          setLoading(false);
          setError("No token or remote_id found");
        }
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await fetch(
          `${apiBaseUrl}/api/user/show?remote_id=${remoteId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch user data");

        const data = await response.json();

        if (isMounted) {
          setUser(normalizeUserData(data));
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        if (isMounted) {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchUserData();

    return () => {
      isMounted = false;
    };
  }, [userProp, apiBaseUrl]);

  const formattedMainBalance = useMemo(() => {
    return Number(user.mainBalance || 0).toLocaleString("en-BD", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }, [user.mainBalance]);

  const formattedEventWallet = useMemo(() => {
    return Number(user.freeEventWallet || 0).toLocaleString("en-BD", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }, [user.freeEventWallet]);

  return (
    <div className={`binfo-hero ${className}`}>
      <div className="binfo-avatar-wrap">
        <img
          src="../../images/avtar-bg.png"
          alt="User avatar"
          className="binfo-avatar-image"
        />
      </div>

      <div className="binfo-hero-copy">
        <div className="binfo-hero-name">
          {loading ? "Loading..." : user.username}
        </div>

        <div className="binfo-balance-row">
          Main Balance (BDT) : <span>{formattedMainBalance}</span>
        </div>

        {/* <div className="binfo-balance-row">
          Free Event Wallet (BDT) : <span>{formattedEventWallet}</span>
        </div> */}

        {error ? <div className="binfo-error">{error}</div> : null}
      </div>
    </div>
  );
}

export default memo(UserBalanceHero);